var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "user-data" }, [
      _c("div", { staticClass: "container" }, [
        _c("div", { staticClass: "row justify-content-center" }, [
          _c("div", { staticClass: "col-md-12 col-lg-11" }, [
            _c("div", { staticClass: "title-row" }, [
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-md-12" }, [
                  _c("p", { staticClass: "p-title Raleway p-black" }, [
                    _c("b", [_vm._v("Data confirmation")])
                  ]),
                  _vm._v(" "),
                  _c("p", { staticClass: "Raleway min-med p-dgrey" }, [
                    _vm._v(
                      "If you have any questions, email us info@tecknael.se or call us 0731234321."
                    )
                  ])
                ])
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "confirm-data" }, [
              _c("div", { staticClass: "download-section" }, [
                _c("div", { staticClass: "download_item" }, [
                  _c("a", { attrs: { href: "#" } }, [_vm._v("Print")]),
                  _vm._v(" "),
                  _c("img", {
                    attrs: { src: "/img/icon/printer.svg", alt: "" }
                  })
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "download_item" }, [
                  _c("a", { attrs: { href: "#" } }, [_vm._v("Download PDF")]),
                  _vm._v(" "),
                  _c("img", { attrs: { src: "/img/icon/pdf.svg", alt: "" } })
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "detail__dash" }, [
                _c("div", { staticClass: "main__dashboard" }, [
                  _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "col-md-6 brdr-right" }, [
                      _c("div", { staticClass: "dashboard__blck left__blck" }, [
                        _c("div", { staticClass: "titles" }, [
                          _c("p", { staticClass: "Raleway max-max p-black" }, [
                            _c("b", [_vm._v("Customer details")])
                          ])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "checked__data" }, [
                          _c("div", { staticClass: "row" }, [
                            _c("div", { staticClass: "col-5" }, [
                              _c("p", { staticClass: "p-black min" }, [
                                _c("b", [_vm._v("Name:")])
                              ])
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "col-7" }, [
                              _c("p", { staticClass: "min" }, [
                                _vm._v("Peter Nordström")
                              ])
                            ])
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "row" }, [
                            _c("div", { staticClass: "col-5" }, [
                              _c("p", { staticClass: "p-black min" }, [
                                _c("b", [_vm._v("Postnummer:")])
                              ])
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "col-7" }, [
                              _c("p", { staticClass: "min" }, [
                                _vm._v("132313-5312")
                              ])
                            ])
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "row" }, [
                            _c("div", { staticClass: "col-5" }, [
                              _c("p", { staticClass: "p-black min" }, [
                                _c("b", [_vm._v("Phone:")])
                              ])
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "col-7" }, [
                              _c("p", { staticClass: "min" }, [
                                _vm._v("0731234321")
                              ])
                            ])
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "row" }, [
                            _c("div", { staticClass: "col-5" }, [
                              _c("p", { staticClass: "p-black min" }, [
                                _c("b", [_vm._v("Fakturaadress:")])
                              ])
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "col-7" }, [
                              _c("p", { staticClass: "min" }, [
                                _vm._v("Markvardsgatan 15 113 54 Stockholm")
                              ])
                            ])
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "row" }, [
                            _c("div", { staticClass: "col-5" }, [
                              _c("p", { staticClass: "p-black min" }, [
                                _c("b", [_vm._v("Fakturaadress:")])
                              ])
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "col-7" }, [
                              _c("p", { staticClass: "min" }, [
                                _vm._v("Markvardsgatan 15 113 54 Stockholm")
                              ])
                            ])
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "row" }, [
                            _c("div", { staticClass: "col-5" }, [
                              _c("p", { staticClass: "p-black min" }, [
                                _c("b", [_vm._v("Area ID:")])
                              ])
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "col-7" }, [
                              _c("p", { staticClass: "min" }, [_vm._v("TYR")])
                            ])
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "row" }, [
                            _c("div", { staticClass: "col-5" }, [
                              _c("p", { staticClass: "p-black min" }, [
                                _c("b", [_vm._v("Plant ID:")])
                              ])
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "col-7" }, [
                              _c("p", { staticClass: "min" }, [
                                _vm._v("423432342341432")
                              ])
                            ])
                          ])
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-md-6" }, [
                      _c("div", { staticClass: "dashboard__blck right_blck" }, [
                        _c("div", { staticClass: "titles" }, [
                          _c("p", { staticClass: "Raleway max-max  p-black" }, [
                            _c("b", [_vm._v("Contract information")])
                          ])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "checked__data" }, [
                          _c("div", { staticClass: "row" }, [
                            _c("div", { staticClass: "col-5" }, [
                              _c("p", { staticClass: "p-black min" }, [
                                _c("b", [_vm._v("Company name:")])
                              ])
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "col-7" }, [
                              _c("p", { staticClass: "min" }, [
                                _vm._v("Peter Nordström")
                              ])
                            ])
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "row" }, [
                            _c("div", { staticClass: "col-5" }, [
                              _c("p", { staticClass: "p-black min" }, [
                                _c("b", [_vm._v("Org.nummer:")])
                              ])
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "col-7" }, [
                              _c("p", { staticClass: "min" }, [
                                _vm._v("132313-5312")
                              ])
                            ])
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "row" }, [
                            _c("div", { staticClass: "col-5" }, [
                              _c("p", { staticClass: "p-black min" }, [
                                _c("b", [_vm._v("Avtalsform:")])
                              ])
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "col-7" }, [
                              _c("p", { staticClass: "min" }, [
                                _vm._v("Fast pris")
                              ])
                            ])
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "row" }, [
                            _c("div", { staticClass: "col-5" }, [
                              _c("p", { staticClass: "p-black min" }, [
                                _c("b", [_vm._v("Avtalssstart:")])
                              ])
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "col-7" }, [
                              _c("p", { staticClass: "min" }, [
                                _vm._v("2019-02-15")
                              ])
                            ])
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "row" }, [
                            _c("div", { staticClass: "col-5" }, [
                              _c("p", { staticClass: "p-black min" }, [
                                _c("b", [_vm._v("Bindninnstid:")])
                              ])
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "col-7" }, [
                              _c("p", { staticClass: "min" }, [
                                _vm._v("3 manader")
                              ])
                            ])
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "row" }, [
                            _c("div", { staticClass: "col-5" }, [
                              _c("p", { staticClass: "p-black min" }, [
                                _c("b", [_vm._v("Betalningssatt:")])
                              ])
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "col-7" }, [
                              _c("p", { staticClass: "min" }, [
                                _vm._v("Faktura")
                              ])
                            ])
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "row" }, [
                            _c("div", { staticClass: "col-5" }, [
                              _c("p", { staticClass: "p-black min" }, [
                                _c("b", [_vm._v("Ovrigt:")])
                              ])
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "col-7" }, [
                              _c("p", { staticClass: "min" }, [
                                _vm._v("Faktura")
                              ])
                            ])
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "row" }, [
                            _c("div", { staticClass: "col-5" }, [
                              _c("p", { staticClass: "p-black min" }, [
                                _c("b", [_vm._v("Elpris:")])
                              ])
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "col-7" }, [
                              _c("p", { staticClass: "min" }, [
                                _vm._v("78.01 öre / kWh incl")
                              ])
                            ])
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "row" }, [
                            _c("div", { staticClass: "col-5" }, [
                              _c("p", { staticClass: "p-black min" }, [
                                _c("b", [_vm._v("Manadsavgift:")])
                              ])
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "col-7" }, [
                              _c("p", { staticClass: "min" }, [
                                _vm._v("15.20 kr")
                              ])
                            ])
                          ])
                        ])
                      ])
                    ])
                  ])
                ])
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "win__blck" }, [
              _c("div", { staticClass: "big_title" }, [
                _c("h1", { staticClass: "p-title p-black mb-0" }, [
                  _vm._v("What is happening now")
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "content" }, [
                _c("p", [
                  _vm._v(
                    "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum."
                  )
                ]),
                _vm._v(" "),
                _c("hr")
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "content" }, [
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-md-7" }, [
                    _c("h4", [_vm._v("Want to try to win Apple Watch?")]),
                    _vm._v(" "),
                    _c("p", [
                      _vm._v(
                        "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum."
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-md-5 text-center" }, [
                    _c("img", {
                      attrs: {
                        src: "/img/38-alu-space-sport-black-nc-1up_GEO_RU.png",
                        alt: ""
                      }
                    })
                  ])
                ])
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "row justify-content-center btns" }, [
              _c("div", { staticClass: "col-md-6" }, [
                _c("button", { staticClass: "btn btn-green btn-full" }, [
                  _vm._v("I want to win ")
                ])
              ])
            ])
          ])
        ])
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }